export default __webpack_public_path__ + "static/hero-energie-si-clima-m-55731e021b3f2f05eb20c6607b930bee.jpg";